import { Dialog } from '@e3dc-react/shell/Elements/Dialog'
import { TextField } from '@e3dc-react/shell/Elements/InputFields'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Typography } from '@mui/material'
import React from 'react'
import useShopSavedSystemConfiguration from '../../hooks/use-shop-saved-system-configuration'
import { useTypedSelector } from 'src/State/RootReducer'
import { updateLabel } from 'src/State/ShopSystemConfiguration/ShopSystemConfigurationAction'
import { useDispatch } from 'react-redux'
import { useSnackbar } from '@e3dc-react/shell/Hooks/Snackbar'

export interface ShopSaveSystemConfigurationProps {
  onConfirm: () => void
  place: number
  onClose: () => void
}

/*
 * This component is a modal with an input field for name of the configurator and saves it
 */
const ShopSaveSystemConfigurationModal: React.FC<ShopSaveSystemConfigurationProps> = ({ onClose, place, onConfirm }) => {
  const { t } = useCustomTranslation()
  const dispatch = useDispatch()
  const { enqueueSuccessStack, enqueueErrorStack } = useSnackbar()
  const { saveSystemConfiguration, isLoading } = useShopSavedSystemConfiguration()
  const configuratorItems = useTypedSelector(state => state.systemStorage.items)
  const configurator = configuratorItems.length > 0 ? configuratorItems[0] : null
  const isLabelEmpty = configurator?.label === ''
  const modalActions = {
    primary: {
      name: t('common.save'),
      disabled: isLabelEmpty,
      onClick: () => {
        configurator !== null &&
          saveSystemConfiguration(configurator)
            .then(() => {
              enqueueSuccessStack(t('shop.save-system-configure.saved-successfully'))
              onConfirm()
              onClose()
            })
            .catch(error => {
              console.error(error)
              enqueueErrorStack(t('shop.save-system-configure.save-failed'))
              onClose()
            })
      },
      isLoading: isLoading,
    },
    secondary: [
      {
        name: t('common.cancel'),
        onClick: () => onClose(),
      },
    ],
  }

  return (
    <Dialog title={t('shop.save-system-configure.title')} onClose={onClose} actions={modalActions} maxWidth="sm" place={place}>
      <Typography variant="h4">{t('shop.save-system-configure.save-message')}</Typography>
      <TextField
        label={t('shop.save-system-configure.name-label')}
        onChange={event => {
          dispatch(updateLabel(event))
        }}
      />
    </Dialog>
  )
}

export default ShopSaveSystemConfigurationModal
